
define('text!modules/creatives/video/templates/details.html',[],function () { return '<div class="details check-radio-forms"></div>\n{{>footer}}';});

